/**
 * @copyright Copyright 2024-2024 Epic Systems Corporation
 * @file AJAX functions for Questionnaires
 * @module Epic.AppOrchard.Core.Questionnaire.Data
 */

import {
	IBuildAcknowledgementTextRequestModel,
	IBuildAcknowledgementTextResponseModel,
	ISaveAttestationAcknowledgementModel,
	ISaveQuestionnaireRequestModel,
	ISaveQuestionnaireTestResponseModel,
} from "ao/data";
import { IGenericResponseModel } from "ao/types";
import api from "ao/utils/api";

export async function saveQuestionnaire(
	data: ISaveQuestionnaireRequestModel,
): Promise<IGenericResponseModel> {
	const result: IGenericResponseModel = await api.post<IGenericResponseModel>(
		"/api/Questionnaire/Save",
		data,
	);
	return result;
}

export async function saveAttestationAcknowledgement(
	data: ISaveAttestationAcknowledgementModel,
): Promise<IGenericResponseModel> {
	const result: IGenericResponseModel = await api.post<IGenericResponseModel>(
		"/api/Questionnaire/SaveAttestationAcknowledgement",
		data,
	);
	return result;
}

export async function buildAcknowledgementText(
	data: IBuildAcknowledgementTextRequestModel,
): Promise<IBuildAcknowledgementTextResponseModel> {
	const result: IBuildAcknowledgementTextResponseModel = await api.post<IBuildAcknowledgementTextResponseModel>(
		"/api/Questionnaire/BuildAcknowledgementText",
		data,
	);
	return result;
}

export async function testProcessHooks(
	data: ISaveQuestionnaireRequestModel,
): Promise<ISaveQuestionnaireTestResponseModel> {
	const result: ISaveQuestionnaireTestResponseModel = await api.post<ISaveQuestionnaireTestResponseModel>(
		"/api/Questionnaire/TestProcessHooks",
		data,
	);
	return result;
}
